import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { cloneDeep, some } from 'lodash';
import { Options } from 'ng5-slider';
import { NGXLogger } from 'ngx-logger';
import { Address, AddressMapComponent, AddressService, Costmodel, CrudService, Customer, Delivery, DeliveryService, Depo, DialogService, Dispatch, DispatchSegment, DispatchService, DispatchStatus, ENDICON, Icons, isValidDate, MapComponent, MapMarker, MapPosition, MessageService, ModalWrapperComponent, ORVRoute, OrvRoutePrefix, SaDatePipe, Search, STARTICON, User, Vehicle, VehicleMapItem, VehicleService } from 'orv-ui-base-lib';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { AclService } from '../../data/acl.service';
import { KpitableComponent } from './kpitable/kpitable.component';

const DELTA = 100000;
const POLY_WEIGHT_ORIG = 1.5;
const POLY_OPACITY_ORIG = 0.8;

const POLY_OPACITY_OPT = 0.8;
const POLY_WEIGHT_OPT = 1.5;

const POLY_WEIGHT_CURRENT = 1.5;
const POLY_OPACITY_CURRENT = 0.8;

const POLY_WEIGHT_REALTIME = 1.5;
const POLY_OPACITY_REALTIME = 0.8;

const MINHEIGHT = 650;

@Component({
	selector: 'app-route-planner',
	templateUrl: './route-planner.component.html',
	styleUrls: ['./route-planner.component.scss']
})
export class RoutePlannerComponent implements OnInit, OnDestroy, AfterViewInit {


	datePipe = new SaDatePipe('en');
	CURRENTPREFIX = OrvRoutePrefix.CURRENTPREFIX;
	OPTIMIZEDPREFIX = OrvRoutePrefix.OPTIMIZEDPREFIX;
	REALTIMEPREFIX = OrvRoutePrefix.REALTIMEPREFIX;
	ORIGINALPREFIX = OrvRoutePrefix.ORIGINALPREFIX;


	CURRENTCOLOR = '#fc1616';

	OPTIMIZEDCOLOR = '#9a4fbc';

	ORIGINALCOLOR = '#707577';

	REALTIMECOLOR = '#000';

	value: number = 100;
	options: Options = {
		floor: 0,
		ceil: 200
	};
	inprogressDelivery: number;
	returnpresent: boolean;
	loadingrealtime: boolean;
	editorder: boolean;

	todaysDate: string = new Date().toISOString().slice(0, 10);
	@Input()
	set extraheight(value: number) {
		this.adjustContainer(value);
	}

	route: ORVRoute;

	@Input()
	set dispatch(value: Dispatch) {

		if (this._dispatch !== value) {
			this._dispatch = value;
			this.initDispatch();
		}

	}

	get dispatch(): Dispatch {
		return this._dispatch;
	}

	_dispatch: Dispatch;

	optimizedRoute: ORVRoute;
	notoptimizedRoute: ORVRoute;
	selectedCustomer: Customer;

	addDeliveryClicked: boolean = false;

	@Input()
	editable: boolean;

	customer: Customer;
	_loading: boolean = false;

	numprcls: number;

	get loading() {
		return this._loading;
	}

	set loading(value: boolean) {
		this._loading = value;
		if (value && this.onloading) {
			this.onloading.emit();
		} else if (!value && this.onready) {
			this.onready.emit();
		}
	}

	depoSearch: Search = new Search('depo');
	costmodelSearch: Search = new Search('costmodel');
	depoEntityClass: ClassType<Depo> = Depo;

	costmodelEntityClass: ClassType<Costmodel> = Costmodel;

	vehicleclass: string;


	@ViewChild('map') map: MapComponent;
	@ViewChild('container') container: ElementRef;
	@ViewChild('topdata') topdata: ElementRef;
	@ViewChild('leftpanel') leftpanel: ElementRef;
	@ViewChild('scrollable') scrollable: ElementRef;


	optimize: boolean;
	marker: any;

	optimizedPolylines: DispatchSegment[];
	polylines: DispatchSegment[];
	originalPolylines: DispatchSegment[];
	realtimePolylines: DispatchSegment[];
	dispatchPolyline: MapPosition[];
	dispatchlocations: MapPosition[] = []; // incremental locations
	dispatchstart: number;
	dispatchstop: number;


	showoptimizedroute: boolean;
	showcurrentroute: boolean;
	showrealtimeroute: boolean;
	showoriginalroute: boolean;
	showpanel: boolean = false;
	showmap: boolean = true;
	showcalcsaveorder: boolean = true;
	showmappane: boolean = false;
	routepanelacl: boolean = false;
	showresetorder: boolean = true;
	showapplyoptimized: boolean = true;
	showapplyoptimizedandsave: boolean = true;


	moreinfo: boolean;
	moreinfomarker: any;
	showslider: boolean;
	sliderstartvalue: number;
	sliderstopvalue: number;
	slideroptions: Options;
	realtimeupdate: boolean;

	returnvisible: any;
	originaladded: boolean;
	simulating: boolean;
	optimizedadded: boolean;

	returnsegment: any = {};
	segmentsVisibility: any = {};
	segmentsPresence: any = {};
	slidermaxvalue: number;

	rangeloaded: boolean;

	@Output() onloading: EventEmitter<any> = new EventEmitter<any>();
	@Output() onready: EventEmitter<any> = new EventEmitter<any>();

	selectedDriver: User;
	selectedVehicle: Vehicle;

	oldDepoSelected: Depo;
	isCommercial: boolean;

	deliverymode: string;
	nextclicked: boolean = false;
	calculateClicked: boolean = false;

	get selectedStartDepo() {
		return this.route.depo;
	}
	set selectedStartDepo(value) {
		this.route.depo = value;
	}
	get selectedStopDepo() {
		return this.route.returndepo;
	}
	set selectedStopDepo(value) {
		this.route.returndepo = value;
	}

	constructor(private logger: NGXLogger, private customerService: CrudService<Customer>,
		private modalService: NgbModal,
		private addressService: AddressService,
		private vehicleService: VehicleService,
		private dispatchService: DispatchService,
		public aclService: AclService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private cdr: ChangeDetectorRef,
		private _el: ElementRef,
		private router: Router,
		private dialogService: DialogService,
		private deliveryService: DeliveryService) {
		this.costmodelSearch.addNotEqualFilter('literkm', 0);
		this.route = new ORVRoute();
		this.returnvisible = {};
		this.returnvisible[this.OPTIMIZEDPREFIX] = true;
		this.returnvisible[this.CURRENTPREFIX] = true;
		this.isCommercial = environment.commercial;
	}

	ngOnInit() {
		this.setAclFeatures();

		this.route.departuredate = new Date().getTime();

	}

	ngOnDestroy(): void {
	}

	ngAfterViewInit() {
		this.adjustMap();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.adjustMap();
	}

	toggleShowmap() {
		this.showmap = !this.showmap;
		if (!this.showmap) {
			this.showpanel = true;
		}
	}

	toggleShowpanel() {
		this.showpanel = !this.showpanel;
		if (!this.showpanel) {
			this.showmap = true;
		}
	}



	adjustMap() {
		/*  if (this.map && this.container) {
			let h = this.container.nativeElement.offsetHeight;
			if (this.topdata && this.topdata.nativeElement) {
			  h = h - this.topdata.nativeElement.offsetHeight - 40;
	  
			}
			this.map.setSize(undefined, h);
		  }*/
	}

	adjustContainer(extraheight: number) {
		/*  if (extraheight && window.innerHeight > MINHEIGHT) {
			if (this.container) {
			  this.adjustArea(this.container, extraheight);
			}
			if (this.leftpanel) {
			  this.adjustArea(this.leftpanel, extraheight);
			}
	  
			if (this.scrollable) {
			  this.adjustArea(this.scrollable, extraheight);
			}
	  
	  
			this.adjustMap();
		  }*/
	}

	adjustArea(area: ElementRef, extraheight: number) {
		/*  let h = area.nativeElement.offsetHeight;
		  h = h - extraheight;
		  area.nativeElement.style.height = h + 'px';*/
	}

	initDispatch() {

		if (this.map) {
			this.map.removePolylines();
		}
		if (this.dispatch && !this.dispatch.importissue) {
			this.route = new ORVRoute(this.dispatch);
		}

		if (this.route.waypoints && this.route.waypoints.length && this.route.valid) {
			this.loading = true;
			this.optimize = true;
			this.calculate();

		}

		if (this.dispatch && (this.dispatch.status === DispatchStatus.ONRIDE || this.dispatch.status === DispatchStatus.COMPLETED)) {
			this.dispatchPolyline = [];
			this.dispatchstart = 0;
			this.dispatchstop = DELTA;
			this.initSlider();
		}



	}

	initSlider() {
		this.showslider = true;
		this.sliderstartvalue = this.dispatch.startdate ? this.dispatch.startdate : 0;
		this.slidermaxvalue = this.dispatch.stopdate ? this.dispatch.stopdate : new Date().getTime();
		this.sliderstopvalue = this.dispatch.stopdate ? this.dispatch.stopdate : new Date().getTime();
	}



	// called when time range change on "gantt" slider
	updateTimeRange(start: Date, stop: Date, fullrange?: boolean) {

		if (isValidDate(start) && isValidDate(stop) && (start.getTime() !== this.sliderstartvalue || stop.getTime() !== this.sliderstopvalue)) {
			this.sliderstartvalue = start.getTime();
			this.sliderstopvalue = stop.getTime();
			this.cdr.detectChanges();
			if (this.rangeloaded) {
				this.updateLocations(undefined, fullrange);
			}
			this.rangeloaded = true; // I need this to avoid double load at the beginning (check doesn't work because range is initialized with diapatch time and not delivery time)
		}

	}



	// update real time locations based on current selection on slider
	updateLocations(event: any, fullrange: boolean = false) {
		if (this.dispatch) {
			this.loadingrealtime = true;
			this.cdr.detectChanges();
			this.removePolylines(this.realtimePolylines, this.REALTIMEPREFIX);
			this.segmentsVisibility = {};
			this.segmentsPresence = {};
			this.returnvisible = {};
			this.togglePolylines(this.optimizedPolylines, fullrange, this.OPTIMIZEDPREFIX);
			this.togglePolylines(this.originalPolylines, fullrange, this.ORIGINALPREFIX);
			this.togglePolylines(this.polylines, fullrange, this.CURRENTPREFIX);
			this.showcurrentroute = false;
			this.showoptimizedroute = fullrange;
			this.showoriginalroute = fullrange;

			this.realtimeupdate = false;
			this.showrealtimeroute = false;


			this.loadLocationsInTimeRange(this.sliderstartvalue, this.sliderstopvalue);

		}
	}

	// load real time locations based on time range selection 
	loadLocationsInTimeRange(start, stop) {
		if (this.dispatch && start && stop) {
			this.dispatchService.getRealSegments(this.dispatch.id, start, stop).subscribe(locations => {
				this.realtimePolylines = locations;
				this.addPolylines(this.realtimePolylines, this.REALTIMECOLOR, this.REALTIMEPREFIX, POLY_WEIGHT_REALTIME, POLY_OPACITY_REALTIME);
				this.showrealtimeroute = true;
				this.route.createCurrentMap(locations);
				if (locations && locations.length === this.route.waypoints.length + 1) {
					this.returnvisible[this.REALTIMEPREFIX] = true; // this is visible only if segments number equals delivery number + 1
					this.returnpresent = true;
				} else if (locations && locations.length) { // else the last segment belongs to the "in progress" delivery
					this.returnvisible[this.REALTIMEPREFIX] = false;
					this.returnpresent = false;
					this.segmentsVisibility.inprogress = true;
					this.inprogressDelivery = locations[locations.length - 1].fromdelid;
				}
				this.loading = false;
				this.loadingrealtime = false;
				this.cdr.detectChanges();

			}, error => {
				this.messageService.sendError(error);
				this.loading = false;
				this.loadingrealtime = false;
			});
		}
		if (this.dispatch.isStatusOnRide) {
			this.loadVehiclePosition();
		}

	}

	loadVehiclePosition() {
		if (this.dispatch && this.dispatch.vehicle && this.dispatch.vehicle.fleetcode) {
			this.vehicleService.getMapById(this.dispatch.vehicle.id).subscribe(items => {
				if (items && items.length && this.map) {
					const v: VehicleMapItem = items[0];
					v.truckicon = true;
					this.map.addMarker(v);

				}
			});
		}
	}


	addStartStopMarkers(locations: MapPosition[]) {
		console.log('addStartStopMarkers');
		if (locations.length) {
			const startMarker: MapMarker = {
				id: 'start',
				lat: locations[0].lat,
				lng: locations[0].lng,
				icon: Icons.PHYSICALSTART
			};

			// this.map.addMarker(startMarker, true); c'è già il depot

			if (this.dispatch && this.dispatch.status !== DispatchStatus.ONRIDE && !this.route.comeback) { // not adding it if return to depot because they overlap
				const lastIndex = locations.length - 1;
				const endMarker: MapMarker = {
					id: 'end',
					lat: locations[lastIndex].lat,
					lng: locations[lastIndex].lng,
					icon: 'assets/images/map/pointer-end.svg'
				};
				this.map.addMarker(endMarker, true);

			}
		}
	}


	dragStart(del: Delivery) {
		if (this.map && del) {
			this.map.highlightMarker(del, true);
			this.map.moveToLocation(del);
		}
	}

	dragEnd(del: Delivery) {
		if (this.map && del) {
			this.map.highlightMarker(del, false);
		}
	}


	dragCanceled(del: Delivery) {
		if (this.map && del) {
			this.map.highlightMarker(del, false);
		}
	}

	highlightDelivery(del: Delivery) {
		if (this.map) {
			this.map.closeAllInfoWindows();
			this.onMarkerClicked(del);
			this.map.moveToLocation(del);
		}
	}


	toggleReturn(prefix: string, show: boolean) {
		if (this.map) {

			this.map.togglePolyline(prefix + this.returnsegment[prefix], show);
		}

	}

	toggleReturnCurrent(show?: boolean) {

		this.toggleReturn(this.CURRENTPREFIX, show);
		this.checkCurrentRouteVisibility(show);
	}

	toggleReturnOptimized(show?: boolean) {
		this.toggleReturn(this.OPTIMIZEDPREFIX, show);
		this.checkOptmizedRouteVisibility(show);
	}


	toggleReturnOriginal(show?: boolean) {
		this.toggleReturn(this.ORIGINALPREFIX, show);
		this.checkOriginalRouteVisibility(show);
	}

	toggleReturnRealtime(show?: boolean) {
		this.toggleReturn(this.REALTIMEPREFIX, show);
		this.checkRealtimeRouteVisibility(show);
	}

	toggleCurrentSegment(from: Delivery, to: Delivery, show?: boolean) {

		const fid = from ? from.id : '';
		const tid = to ? to.id : '';
		const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.CURRENTPREFIX];
		if (to && sh) {
			this.highlightDelivery(to);
		}
		this.checkCurrentRouteVisibility(sh);
		this.toggleSegment(fid, tid, this.CURRENTPREFIX, sh);
	}

	toggleOptimizedSegment(to: Delivery, show?: boolean) {
		if (!this.optimizedadded) {
			this.togglePolylines(this.optimizedPolylines, false, this.OPTIMIZEDPREFIX);
		}

		const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.OPTIMIZEDPREFIX];

		if (to && sh) {
			this.highlightDelivery(to);
		}
		this.checkOptmizedRouteVisibility(sh);
		if (to && this.optimizedRoute && this.optimizedRoute.optimizedMap && this.optimizedRoute.optimizedMap[to.id]) {
			this.toggleSegment(this.optimizedRoute.optimizedMap[to.id].fromdelid, to.id, this.OPTIMIZEDPREFIX, sh);
		}
	}

	toggleRealtimeSegment(to: Delivery, show?: boolean, inprogress?: boolean) {

		if (inprogress) {
			this.toggleReturn(this.REALTIMEPREFIX, show);

		} else {

			const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.REALTIMEPREFIX];

			/*if (to && sh) {
			  this.highlightDelivery(to);
			}*/
			this.checkRealtimeRouteVisibility(sh);
			if (to && this.route && this.route.currentMap && this.route.currentMap[to.id]) {
				this.toggleSegment(this.route.currentMap[to.id].fromdelid, to.id, this.REALTIMEPREFIX, sh);
			}
		}
	}



	toggleOriginalSegment(to: Delivery, show?: boolean) {

		if (!this.originaladded) {
			this.togglePolylines(this.originalPolylines, false, this.ORIGINALPREFIX);
		}
		const sh = show !== undefined ? show : this.segmentsVisibility[to.id][this.ORIGINALPREFIX];

		if (to && sh) {
			this.highlightDelivery(to);
		}
		this.checkOriginalRouteVisibility(sh);
		if (to && this.notoptimizedRoute && this.notoptimizedRoute && this.notoptimizedRoute.originalMap[to.id]) {
			this.toggleSegment(this.notoptimizedRoute.originalMap[to.id].fromdelid, to.id, this.ORIGINALPREFIX, sh);
		}
	}

	toggleSegment(from: any, to: any, prefix: string, show?: boolean) {

		let id = '';
		let visible = true;

		if (from !== undefined && from !== null) {
			id = id + from;
		}


		if (to !== undefined && to !== null) {
			if (to !== '') {
				id = id + '-' + to;
			}
			visible = show;
		} else {
			id = id + '-' + from;
			visible = show;
		}



		if (this.map) {

			this.map.togglePolyline(prefix + id, visible);

		}
	}

	checkRealtimeRouteVisibility(show: boolean) {

		if (show && this.checkRouteVisibility(this.REALTIMEPREFIX) && this.returnvisible[this.REALTIMEPREFIX]) {
			this.showrealtimeroute = true;
		} else {
			this.showrealtimeroute = false;
		}
	}


	checkOptmizedRouteVisibility(show: boolean) {
		if (show && this.checkRouteVisibility(this.OPTIMIZEDPREFIX) && this.returnvisible[this.OPTIMIZEDPREFIX]) {
			this.showoptimizedroute = true;
		} else {
			this.showoptimizedroute = false;
		}
	}

	checkOriginalRouteVisibility(show: boolean) {
		if (show && this.checkRouteVisibility(this.ORIGINALPREFIX) && this.returnvisible[this.ORIGINALPREFIX]) {
			this.showoriginalroute = true;
		} else {
			this.showoriginalroute = false;
		}
	}
	checkCurrentRouteVisibility(show: boolean) {
		if (show && this.checkRouteVisibility(this.CURRENTPREFIX) && this.returnvisible[this.CURRENTPREFIX]) {
			this.showcurrentroute = true;
		} else {
			this.showcurrentroute = false;
		}
	}
	checkRouteVisibility(prefix: string) {

		const visibility = this.segmentsVisibility;
		return !some(this.route.waypoints, function (el) {
			return !visibility[el.id][prefix];
		});
	}

	onMarkerClicked(event: any) {
		this.marker = event;
		this.cdr.detectChanges();
		const html = this._el.nativeElement.querySelector('#infowindow').innerHTML;
		this.map.openInfoWindow(this.marker, html);
		this.markerMoreInfo(this.marker);
	}

	onMarkerHighlight(event: any) {

	}

	boundsChanged(event: any) {
	}


	addDepo(depo: Depo, old?: Depo) {
		if (depo) {
			depo.clickable = true;
			depo.infoWindow = false;
			this.map.addMarker(depo, true);
			if (this.oldDepoSelected && depo.id !== this.oldDepoSelected.id) {
				this.map.removeMarker(this.oldDepoSelected, true);
			}
			if (this.route.comeback) {
				this.route.returndepo = this.route.depo;
				this.addReturnDepo(this.route.depo, this.route.returndepo);
			}
			if (this.route.returndepo && this.route.depo.id === this.route.returndepo.id) {
				this.route.comeback = true;
			}

			this.oldDepoSelected = depo;

		} else if (this.route.startingfrom) {
			this.map.addMarkerAtLatLng(this.route.startinglat, this.route.startinglng, this.route.startingfrom, 'startingpoint', STARTICON, true);
		}
	}


	addReturnDepo(depo: Depo, old?: Depo) {
		if (depo) {

			if (this.route.depo.id !== depo.id) {
				depo.clickable = true;
				depo.infoWindow = false;
				depo.icon = ENDICON;
				this.map.addMarker(depo, true);
				this.route.comeback = false;
			} else {
				this.route.comeback = true;
			}
			if (old && this.route.depo && old.id !== this.route.depo.id) {
				this.map.removeMarker(old, true);
			}
		} else if (this.route.goingto && this.route.goingto !== this.route.startingfrom) {
			this.map.addMarkerAtLatLng(this.route.startinglat, this.route.startinglng, this.route.startingfrom, 'goingto', ENDICON, true);
		}
	}

	setComeback(comeback: boolean) {
		if (comeback) {
			this.addReturnDepo(this.route.depo, this.route.returndepo);
			this.route.returndepo = this.route.depo;
		}
	}

	addDelivery(delivery: Customer) {
		this.addDeliveryClicked = true;

		if (delivery && this.numprcls) {
			this.addressService.getAddressesByCid(delivery.id).subscribe((data: Address[]) => {
				if (data && data[0]) {


					const del = this.route.addDelivery(delivery, data[0], undefined, undefined, this.numprcls);
					this.optimize = true;

					let extendedBounds = false;
					if (this.route.waypoints.length > 0 && this.route.waypoints.length < 2) {
						extendedBounds = true;
					}

					this.map.addMarker(del, extendedBounds);

					this.numprcls = undefined;
					this.selectedCustomer = undefined;
					this.addDeliveryClicked = false;

					this.calculateClicked = false;

				} else {
					const messages = this.translateService.instant(['labels.customer-invalid-address', 'labels.error']);
					this.messageService.sendWarn(messages['labels.customer-invalid-address'], messages['labels.error']);
				}
			}, ({ error }) => {
				this.messageService.sendError(error);
			});
		}
	}

	next() {
		if (this.route.departuredate < new Date().getTime()) {
			this.messageService.sendError(this.translateService.instant('labels.future-departuretime'));
			return;
		}

		this.nextclicked = true;

	}

	removeDelivery(event: any) {
		if (this.map && event.data && event.index !== undefined) {
			this.route.removeDelivery(event.index);
			this.map.removeMarker(event.data, true);
			this.optimize = true;
		}
	}

	orderChanged(event: any) {
		this.route.cansavecustom = true;
	}


	editAddress(delivery: Delivery) {

		const address = delivery.customer && delivery.customer.address ? delivery.customer.address : delivery.getAddress();

		const modal = this.modalService.open(ModalWrapperComponent, { centered: true, size: 'lg' });
		modal.componentInstance.component = AddressMapComponent;
		modal.componentInstance.title = this.translateService.instant(address.id || address.tmp ? 'labels.edit-address' : 'labels.new-address');
		modal.componentInstance.inputs = { address: address };
		modal.componentInstance.outputs = {
			save: (a: Address) => {
				modal.close();
				if (a && a.geocoding) {
					this.deliveryService.updateAddress(delivery.id, a.geocoding).subscribe((data: Delivery) => {
						const messages = this.translateService.instant(['labels.address-save-success', 'labels.customer']);
						this.messageService.sendSuccess(messages['labels.address-save-success'], messages['labels.customer']);
						delivery.updateGeocoding(data);
						this.route.cansavecustom = true;
					}, ({ error }) => {
						this.messageService.sendError(error, this.translateService.instant('labels.customer'));
					});
				}
			},
			cancel: () => modal.dismiss()
		};
	}

	calculate() {

		this.loading = true;

		if (this.map) {
			this.map.closeAllInfoWindows();
		}
		this.applyInputOrder();
		this.route.setSortIndex();
		this.route.optimize = false;
		if (this.vehicleclass) {
			this.route.vehicleclass = this.vehicleclass;
		}

		this.calculateOptimize().pipe(concatMap(optimized =>
			this.calculateNotOptimize())).subscribe(notoptimized => {
				this.setResults();
			}, error => {
				this.messageService.sendError(error, error.code);
				this.loading = false;
				this.simulating = false;
			});

	}


	setResults() {

		this.route.setWaypointsData(this.optimizedRoute, this.notoptimizedRoute);
		this.updateMarkers(this.route.waypoints);
		if (this.dispatch && (this.dispatch.status === DispatchStatus.ONRIDE || this.dispatch.status === DispatchStatus.COMPLETED)) {
			this.loadLocationsInTimeRange(this.sliderstartvalue, this.sliderstopvalue);
		} else {
			this.loading = false;
		}

		const modal = this.modalService.open(KpitableComponent, { centered: true, size: 'lg' });
		modal.componentInstance.optimized = this.optimizedRoute;
		modal.componentInstance.notoptimized = this.notoptimizedRoute;
		if (this.dispatch) {
			modal.componentInstance.travelled = this.dispatch;
		}

		this.calculateClicked = true;
	}


	calculateNotOptimize(): Observable<any> {


		this.removePolylines(this.polylines, this.CURRENTPREFIX);


		this.route.customize = true;

		return this.dispatchService.planRoute(this.route).map(data => {
			if (data) {
				this.notoptimizedRoute = data;

				if (!this.optimize && data) {
					this.route.waypoints = data.waypoints;

				}


				this.route.cansavecustom = false;
				this.optimize = false; // turn off optimze. turn on only if deliveries are added. no need to optimize if other data changes

				this.polylines = data.deliveries;

				this.showcurrentroute = true;

				this.logger.log('add current Polylines ');
				this.addPolylines(this.polylines, this.CURRENTCOLOR, this.CURRENTPREFIX, POLY_WEIGHT_CURRENT, POLY_OPACITY_CURRENT);



			}

			return data;

		}, error => {
			// TODO
			this.logger.log(error);
		});

	}


	calculateOptimize(): Observable<any> {

		if ((this.dispatch && this.dispatch.routing === 'optimal') || this.simulating) {
			this.removePolylines(this.polylines, this.CURRENTPREFIX);
		}
		if (!this.optimize) {
			this.showoptimizedroute = true;
			this.togglePolylines(this.optimizedPolylines, true, this.OPTIMIZEDPREFIX);
			return Observable.of(true);
		} else {
			this.removePolylines(this.optimizedPolylines, this.OPTIMIZEDPREFIX);
			const route = cloneDeep(this.route);
			route.optimize = true;
			return this.dispatchService.planRoute(route).map(data => {
				if (data) {
					this.optimizedRoute = data;

					this.route.waypoints = data.waypoints;

					// for (let i = 0; i < this.route.waypoints.length; i++) {
					//   this.route.waypoints[i].optimizedorder = data.waypoints[i].optimizedorder;

					//   console.log("Updated Route:", this.route);
					// }
					this.showoptimizedroute = true;

					this.optimizedPolylines = data.deliveries;
					this.addPolylines(this.optimizedPolylines, this.OPTIMIZEDCOLOR, this.OPTIMIZEDPREFIX, POLY_WEIGHT_OPT, POLY_OPACITY_OPT);
					this.optimizedadded = true;


				}
				return data;

			}, error => {
				this.messageService.sendError(error);

				this.logger.log(error);
			});
		}
	}

	applyCustom() {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-routeplanner-custom'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {

			if (result) {
				this.loading = true;
				this.applyInputOrder();
				this.route.setSortIndex();
				this.dispatch.setSortIndex(this.route.waypoints);
				this.dispatchService.applyCustom(this.dispatch).subscribe(r => {
					this.dispatch = r;
					//this.initDispatch();
					this.messageService.sendSuccess(this.translateService.instant('labels.success-routeplanner-custom'));
				}, error => {
					this.messageService.sendError(error);
					this.loading = false;

				});
			}
		});
	}


	applyOptimized() {
		this.logger.log('applyOptimized');

		this.route.applyOptimized();

		this.applyInputOrder();
		this.route.setSortIndex();
		this.route.optimize = false;

		this.route.setWaypointsData(this.optimizedRoute, this.notoptimizedRoute);
		this.updateMarkers(this.route.waypoints);
		if (this.dispatch && (this.dispatch.status === DispatchStatus.ONRIDE || this.dispatch.status === DispatchStatus.COMPLETED)) {
			this.loadLocationsInTimeRange(this.sliderstartvalue, this.sliderstopvalue);
		} else {
			this.loading = false;
		}

	}

	applyInputOrder() {
		if (this.editorder) {
			this.route.applyInputOrder();
			this.editorder = false;
			this.route.cansavecustom = true;
		}
	}

	reset(routePlanningForm: NgForm) {
		this.nextclicked = false;
		this.route.waypoints = [];
		this.calculateClicked = false;
		routePlanningForm.resetForm();

		this.map.resetMap();
		this.route.departuredate = new Date().getTime();

	}



	toggleRealTimePolyline(show: boolean) {

		this.togglePolylines(this.realtimePolylines, show, this.REALTIMEPREFIX);
	}

	togglePolylines(polilynes: DispatchSegment[], show: boolean, prefix: string) {
		this.logger.log('togglePolylines', prefix, show);
		if (prefix === this.ORIGINALPREFIX && !this.originaladded && show) {
			this.originaladded = true;
			this.addPolylines(this.originalPolylines, this.ORIGINALCOLOR, this.ORIGINALPREFIX, POLY_WEIGHT_ORIG, POLY_OPACITY_ORIG); // I add them 'cause it's the first time
		} else if (prefix === this.OPTIMIZEDPREFIX && !this.optimizedadded && show) {
			this.optimizedadded = true;
			this.addPolylines(this.optimizedPolylines, this.OPTIMIZEDCOLOR, this.OPTIMIZEDPREFIX, POLY_WEIGHT_OPT, POLY_OPACITY_OPT); // I add them 'cause it's the first time

		} else if (polilynes && this.map) {
			for (let index = 0; index < polilynes.length; index++) {
				polilynes[index].decodePolyline();

				if (polilynes[index].todelid !== undefined) {
					if (this.segmentsVisibility[polilynes[index].todelid] === undefined) {
						this.segmentsVisibility[polilynes[index].todelid] = {};
					}
					this.segmentsVisibility[polilynes[index].todelid][prefix] = show;
				}
				this.returnvisible[prefix] = show;
				this.logger.log('togglePolyline', prefix + polilynes[index].polylineid, show);
				this.map.togglePolyline(prefix + polilynes[index].polylineid, show);
			}
		}
	}

	updateMarkers(waypoints: Delivery[]) {
		this.map.markers = waypoints;
		if (this.route.depo) this.map.addMarker(this.route.depo);
		if (this.route.returndepo) this.map.addMarker(this.route.returndepo);

		this.map.zoomToMarkers();
		this.addDepo(this.route.depo);
	}


	addPolylines(deliveries: DispatchSegment[], color: string, prefix: string, weight: number, opacity: number) {

		if (deliveries && this.map) {
			for (let index = 0; index < deliveries.length; index++) {
				deliveries[index].decodePolyline();

				if (deliveries[index].todelid !== undefined) {
					if (this.segmentsVisibility[deliveries[index].todelid] === undefined) {
						this.segmentsVisibility[deliveries[index].todelid] = {};
					}

					if (this.segmentsPresence[deliveries[index].todelid] === undefined) {
						this.segmentsPresence[deliveries[index].todelid] = {};
					}

					this.segmentsVisibility[deliveries[index].todelid][prefix] = true;
					this.segmentsPresence[deliveries[index].todelid][prefix] = true;
				}
				this.returnsegment[prefix] = deliveries[deliveries.length - 1].polylineid;

				this.logger.log('addpolyline', prefix + deliveries[index].polylineid);
				this.map.addPolyline(deliveries[index].polyline, color, prefix + deliveries[index].polylineid, weight, opacity);
			}
		}
	}



	removePolylines(deliveries: DispatchSegment[], prefix: string) {
		if (deliveries && this.map) {
			for (let index = 0; index < deliveries.length; index++) {
				deliveries[index].decodePolyline();
				this.map.removePolyline(prefix + deliveries[index].polylineid);
			}
		}
	}


	markerMoreInfo(marker: any) {

		this.moreinfomarker = marker;
	}

	closeMoreinfopanel() {
		this.moreinfomarker = undefined;
	}

	setAclFeatures() {

		if (this.aclService.hasPermission('routesimulation.reroutingpane')) {
			this.showpanel = true;
			this.routepanelacl = true;

		}

		if (this.aclService.hasPermission('routesimulation.mappane')) {
			this.showmappane = true;

		}

	}

	onVehicleChange() {
		if (this.selectedVehicle) {
			this.route.vehicleid = this.selectedVehicle.id;
		}
	}

	onDriverChange() {
		if (this.selectedDriver) {
			this.route.driverid = this.selectedDriver.id;
		}
	}


}
